import { Container } from "inversify";
import { getContainer as getDSContainer } from "@se/designsystem-core";
import { SiteStartup } from "./siteStartup";
import { SiteEnvironment } from "./environments/siteEnvironment";
import { FBSConfig } from "./configuration/FBSConfig"
import { IFBSFeedbackServiceId,  IFBSFeedbackService } from "./services/interfaces/fbsFeedbackService"
import { FBSFeedbackService } from "./services/implementations/fbsFeedbackService"
import { ApiClient, IApiClient, IApiClientId } from "@se/platform"

const getContainer = function (environment: SiteEnvironment): Container {

	// get the base container from design system...
	var container = getDSContainer(environment);

	// then extend it to add any site-specific bindings here
	//container.bind<>(...)
	container.bind<FBSConfig>(FBSConfig).toConstantValue(environment.fbsConfig);
	container.bind<IFBSFeedbackService>(IFBSFeedbackServiceId).to(FBSFeedbackService).inSingletonScope();


	// setup a binding for the site-specific startup class, and return the container
	container.bind(SiteStartup).toSelf().inSingletonScope();
	return container;
}

export { getContainer };